import { render } from "./OrderHall.vue?vue&type=template&id=b66a1892&scoped=true"
import script from "./OrderHall.vue?vue&type=script&lang=js"
export * from "./OrderHall.vue?vue&type=script&lang=js"

import "./OrderHall.vue?vue&type=style&index=0&id=b66a1892&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66a1892"]])

export default __exports__